import Urls from '@/pages/profile/Urls';
import {useUser} from '@lore/auth';
import {PencilSquareIcon} from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import SiteActiveCard from '@/pages/setup/account/site/SiteActiveCard';
import SiteInactiveCard from '@/pages/setup/account/site/SiteInactiveCard';
import SiteNotFoundCard from '@/pages/setup/account/site/SiteNotFoundCard';

function SiteStatusCard(props) {
  const {site} = props;
  if (!site) return null;

  if (site.isActive) {
    return <SiteActiveCard siteData={site} summaryOnly/>;
  }

  if (site.reviewStatus) {
    return <SiteNotFoundCard siteData={site}/>;
  }

  if (site.isActive === false) {
    return <SiteInactiveCard siteData={site}/>;
  }

  return null;
}

SiteStatusCard.propTypes = {
  site: PropTypes.shape({
    isActive: PropTypes.bool,
    reviewStatus: PropTypes.string
  })
};

export default function SchoolSection() {
  const {t} = useTranslation();
  const currentUser = useUser();
  const navigate = useNavigate();
  const {sites = [], potentialSites = []} = currentUser.data;

  let site = sites.find(s => s.isActive);
  if (!site) site = sites.find(s => s.name);
  if (!site) site = potentialSites.find(s => s.reviewStatus === 'draft');

  function navigateToUserSites() {
    navigate(Urls(currentUser).SITES, {
      state: { returnPath: `${Urls(currentUser).PROFILE_EDIT}#location` }
    });
  }

  return (
    <div className="grid items-start gap-8 grid-cols-[280px_1fr]">
      <div>
        <div className="mb-2 flex items-center space-x-3">
          <h4 className="text-base font-semibold text-cs-gray-900">{t('schools.title')}</h4>
          <button
            type="button"
            className="text-cs-blue-500 hover:opacity-60"
            aria-label={t('schools.editAriaLabel')}
            onClick={navigateToUserSites}
          >
            <PencilSquareIcon className="size-5"/>
          </button>
        </div>
        {site ? (
          <div className="space-y-1 text-base text-cs-gray-500">
            <p>{site.name}</p>
            {site.addressLine1 && <p>{site.addressLine1}</p>}
            {(site.city || site.state || site.zipCode) && (
              <p>{[site.city, site.state, site.zipCode].filter(Boolean).join(', ')}</p>
            )}
          </div>
        ) : <div>{t('schools.emptyState')}</div>}
      </div>
      <SiteStatusCard site={site}/>
    </div>
  );
}
